import React from "react";
import "./bannerMessage.css";

const BannerMessage = ({ type = "info", text, exiting = false }) => {
	if (!text) return null;

	return (
		<div className="sf-banner-wrap">
			<div
				className={[
					"sf-banner",
					`sf-banner--${type}`,
					exiting ? "sf-banner--exit" : "",
				].join(" ")}
			>
				<span className="sf-banner-text">{text}</span>
			</div>
		</div>
	);
};

export default BannerMessage;
